<template>
  <v-tooltip
    top
  >
    <template #activator="{ on, attrs }">
      <div
        class="container-info py-2"
        :class="{
          'is_current' : cycle.is_current
        }"
        v-bind="attrs"
        v-on="on"
      >
        <p
          class="m-0 score-info-text font-weight-bolder"
          :class="{
            'past-text-color': !cycle.is_current && !cycle.score_weight_configured && cycle.started,
            'inative-text-color': !cycle.is_current && !cycle.score_weight_configured && !cycle.started,
            'white--text' : cycle.is_current ,
            'nitro--text' : !cycle.is_current && cycle.score_weight_configured && cycle.started
          }"
        >
          {{ cycle.score_weight_configured && cycle.started ? `${cycle.cycle_score}%` : '-' }}
        </p>
        <p 
          class="m-0 text-center score-sub-text font-weight-bold"
          :class="{
            'past-text-color': !cycle.is_current && cycle.started,
            'inative-text-color': !cycle.is_current && !cycle.started,
            'white--text' : cycle.is_current 
          }"
        >
          Score
        </p>
      </div>
    </template>
    <div v-if="!cycle.score_weight_configured">
      <p>
        Sua escola ainda não configurou o score nitro do ciclo
      </p>
    </div>
    <div v-else-if="!cycle.started">
      <p>
        Este ciclo de estudos ainda não está disponível
      </p>
    </div>
    <div v-else>
      <p>Peso progresso: <span class="font-weight-bold">{{ Number(cycle.module_score_weight * 100).toFixed(0) }}%</span></p>
      <p>Peso desempenho: <span class="font-weight-bold">{{ Number(cycle.challenge_score_weight * 100).toFixed(0) }} %</span></p>
      <p>Progresso alcançado: <span class="font-weight-bold">{{ cycle.goal_progress }}%</span></p>
      <p>Desempenho alcançado: <span class="font-weight-bold">{{ cycle.performance }}%</span></p>
      <p>Média Score nitro: <span class="font-weight-bold">{{ cycle.cycle_score }}%</span></p>
    </div>
  </v-tooltip>
</template>

<script>
export default {
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    }
}
</script>
<style scoped>
  .past-text-color {
    color: #767676
  }.inative-text-color {
    color: #928C99
  }
  .score-info-text {
    font-size: 14px;
    @media screen and (min-width: 768px) {
      font-size: 21px;
    }
  }
  
  .score-sub-text{
    font-size:10px;
    @media screen and (min-width: 768px) {
      font-size: 15px;
    }
  }

  p{
    margin: 0
  }
</style>

